export default {
  contratoAtivo: 'contratoAtivo',
  contratoInexistente: 'contratoInexistente',
};
